import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import _orderBy from 'lodash/orderBy';

import { CEUMA_URL_API } from 'app/config';

import CalendarioProvas from 'mocks/vestibular/calendario-provas';

import { Vestibular, Resultado, ResultadoDia, OpcaoCurso } from 'models/vestibular';
//Adição Thiago
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//-------------
export const VESTIBULAR_API_URL = CEUMA_URL_API + '/vestibularesAbertos/';
export const OPCOES_CURSOS_API_URL = CEUMA_URL_API + '/opcaoCurso/:codigo/:ano';
export const RESULTADOS_API_URL = `${CEUMA_URL_API}/diaResultados/:ano/:codigo`;
export const RESULTADOS_DIA_API_URL = `${CEUMA_URL_API}/resultadosDoDia/:ano/:codigo/:dia`;
export const VESTIBULARES_DISPONIVEIS_POR_CURSO = `${CEUMA_URL_API}/cursos/getVestibularesDisponiveisPeloCurso/:codigo`;
export const CURSOS_ABERTOS_URL = CEUMA_URL_API + '/recuperaCursosAbertos/';
export const FORMAS_DE_INGRESSO_URL = CEUMA_URL_API + '/recuperaFormasIngresso/:codigo/:turno';
export const DADOS_MARKET_PLACE = CEUMA_URL_API + '/marketplace/decode/';
@Injectable()
export class VestibularService {

  private vestibularesCache: Vestibular[];
  private isVestibularesCached = false;
  private opcaoCurso=null;

  constructor(
    private http: HttpClient,
  ) { }

  vestibularesVigentes(): Promise<Vestibular[]> {
    return new Promise<any[]>((resolve, reject) => {
      if (this.isVestibularesCached) {
        resolve(this.filtrarVestibularesVigentes(this.vestibularesCache));
      } else {
        this.doCacheVestibulares((vestibulares) => {
          resolve(this.filtrarVestibularesVigentes(vestibulares));
        });
      }
    });
  }

  cursosVigentes(): Promise<any[]>{
    return new Promise<any[]>((resolve,reject)=>{
      this.doCacheCursosVestibular((cursosVestibulares)=>{
        resolve(cursosVestibulares);
      })
    })
  }

  formasDeIngresso(codigo,turno): Promise<any[]>{
    const url = FORMAS_DE_INGRESSO_URL.replace(':codigo',codigo).replace(":turno",turno);
    return this.http.get<Array<any>>(url)
      .map(data => data.map(res => new Resultado(res)))
      .toPromise();
  }

  vestibularesAbertosPorCurso(idCurso: string): Promise<Vestibular[]> {
    return this.vestibularesVigentes().then(vestibulares => this.filtrarVestibularAbertoPorCurso(vestibulares, idCurso));
  }

  vestibularesComResultados(): Promise<Vestibular[]> {
    return new Promise<Vestibular[]>((resolve, reject) => {
      if (this.isVestibularesCached) {
        resolve(this.filtrarVestibularesComResultado(this.vestibularesCache));
      } else {
        this.doCacheVestibulares((vestibulares) => {
          resolve(this.filtrarVestibularesComResultado(vestibulares));
        });
      }
    });
  }

  getVestibularById(ano: string, codigo: number): Promise<Vestibular> {
    return new Promise<Vestibular>((resolve, reject) => {
      if (this.isVestibularesCached) {
        resolve(this.filtrarVestibularById(this.vestibularesCache, ano, codigo));
      } else {
        this.doCacheVestibulares((vestibulares) => {
          resolve(this.filtrarVestibularById(vestibulares, ano, codigo));
        });
      }
      // resolve(Vestibulares[2]);
    });
  }

  getResultados(ano: any, codigo: any): Promise<Resultado[]> {
    const url = RESULTADOS_API_URL.replace(':ano', ano).replace(':codigo', codigo);
    return this.http
      .get<Array<any>>(url)
      .map(data => data.map(res => new Resultado(res)))
      .toPromise();
  }

  getResultadosDia(ano: any, codigo: any, dia: any): Promise<ResultadoDia[]> {
    const url = RESULTADOS_DIA_API_URL.replace(':ano', ano).replace(':codigo', codigo).replace(':dia', dia);
    return this.http
      .get<Array<any>>(url)
      .map(data => data.map(res => new ResultadoDia(res)))
      .toPromise();
  }

  getOpcoesCursos(ano: any, codigo: any): Promise<OpcaoCurso[]> {
    const url = OPCOES_CURSOS_API_URL.replace(':ano', ano).replace(':codigo', codigo);
    return this.http
      .get<Array<any>>(url)
      .map(res => {
        //console.log(res);
        // reduz juntando cursos com mesmo id e campus com mesmo id
        const tmp = res.reduce((acc, el) => {
          // cria estrutura para curso
          //console.log(acc);
          //console.log(el);
          if (!acc[el.curso.id]) {
            acc[el.curso.id] = {
              id: el.curso.id,
              nome: el.curso.nome,
              campi: {}
            };
          }
          // cria estrutura para campus
          if (!acc[el.curso.id].campi[el.campus.id]) {
            acc[el.curso.id].campi[el.campus.id] = {
              id: el.campus.id,
              nome: el.campus.nome,
              turnos: [],
            };
          }
          //console.log(el);
          //Verifica se tem desconto, caso não tenha, ficar como turno normal
          //console.log(el.valorCurso);
          //console.log(el.valorCursoDesconto);
          //console.log(el.descricaoValorCurso);
          acc[el.curso.id].campi[el.campus.id].turnos.push({
            turno: el.id.turno,
            valorCurso: el.valorCurso,
            valorCursoDesconto: el.valorCursoDesconto,
            descricaoValorCurso: el.descricaoValorCurso,
            exibirWeb: el.exibirWeb
          })
          //console.log(acc[el.curso.id]);
          return acc;
        }, {});

        // transforma objetos em array
        // TODO: refinar uso de foreach de propriedades
        const output: OpcaoCurso[] = [];
        for (const idCurso of Object.keys(tmp)) {
          const curso = tmp[idCurso];
          const campi = [];
          for (const idCampus of Object.keys(curso.campi)) {
            campi.push(curso.campi[idCampus]);
            //console.log(campi);
          }
          curso.campi = campi;
          output.push(new OpcaoCurso(curso));
        }

        // retira turnos duplicados
        output.forEach(curso => {
          curso.campi.forEach(campus => {
            campus.turnos = this.retirarDuplicados(campus.turnos);
          });
        });

        return output;
      })
      .toPromise();
  }

  pegaDadosMarketPlace(data){
    //const headers = { 'Authorization': 'Basic ' + btoa('Ceuma4dmin:'+'c3um4#crm4p1!439') };
    return this.http.post(DADOS_MARKET_PLACE, data);
    //return this.http.post("http://localhost:8089/vestibular-api/marketplace/decode/", data);
  }

  isInscricaoAberta(vestibular: Vestibular): number {


    if (!this.isValidDate(vestibular.dataInscricaoIncial)
      || !this.isValidDate(vestibular.dataInscricaoFinal)) {
      return 0;
    }

    const now = new Date();

    if (now <= vestibular.dataInscricaoFinal
      && now >= vestibular.dataInscricaoIncial) {
      return 1;
    }
    if(now<=vestibular.dataInscricaoIncial){
      return 2;
    }

    return 0;
  }

  calendario(): Promise<{ data, total }> {
    return new Promise<{ data, total }>((resolvido) => {
      resolvido({
        data: CalendarioProvas, total: CalendarioProvas.length,
      });
    });
  }

  /********************
   * METODOS PRIVADOS *
   ********************/

  private retirarDuplicados(arr: any[]) {
    return arr.sort().filter(function (item, pos, ary) {
      return !pos || item !== ary[pos - 1];
    });
  }

  private filtrarVestibularAbertoPorCurso(arrayVestibulares: Vestibular[], idCurso: string): Vestibular[] {
    return arrayVestibulares.filter(vestibular => {
      return this.isInscricaoAberta(vestibular) && vestibular.cursosOfertados.some(curso => curso.codCurso === idCurso);
    });
  }

  private filtrarVestibularById(arrayVestibulares: Vestibular[], ano: string, codigo: number): Vestibular {
    const vestibularArr = arrayVestibulares.filter(
      (vestibular: Vestibular) => vestibular.id && vestibular.id.ano === ano && vestibular.id.codigo === codigo,
    );
    if (vestibularArr !== null && vestibularArr.length > 0) {
      return vestibularArr[0];
    }
    return null;
  }

  private filtrarVestibularesVigentes(arrayVestibulares: Vestibular[]): Vestibular[] {

    return arrayVestibulares;
  }

  private filtrarVestibularesComResultado(arrayVestibulares: Vestibular[]): Vestibular[] {
    return arrayVestibulares.filter(
      (vestibular: Vestibular) =>
        new Date(vestibular.dataResultados).getTime() < Date.now() || vestibular.tipo === 'agendado',
    );
  }

  private doCacheCursosVestibular(callback):void{
    this.http.get(CURSOS_ABERTOS_URL)
    .subscribe(output=>{
      this.isVestibularesCached = true;
      callback(output);
    })
  }

  private doCacheVestibulares(callback): void {
    this.http.get(VESTIBULAR_API_URL)
      .subscribe(output => {
        // console.log(output);
        // sort by anoSemetre desc, titulo asc
        const tmp = _orderBy(output, ['ordem'], ['asc']);

        // tratar dados
        this.vestibularesCache = tmp.map(vestibular => this.tratarDadosVestibular(vestibular));
        this.isVestibularesCached = true;
        callback(this.vestibularesCache);
      });
  }

  private tratarDadosVestibular(vestibular: any): Vestibular {
    if (!vestibular) {
      return null;
    }

    vestibular.sigla = vestibular.sigla.trim();

    // retirar ano semestre do titulo e fazer trim
    vestibular.titulo = vestibular.titulo.replace(/(\d{4}(\.\d)?)/g, '').trim();

    // colocar ponto no anoSemestre
    if (vestibular.anoSemestre !== '' && vestibular.anoSemestre.length === 5) {
      vestibular.anoSemestre = vestibular.anoSemestre.substring(0, 4) + '.' + vestibular.anoSemestre.substring(4);
    }

    // transforma o tipo
    const tipo = vestibular.tipo.trim().toUpperCase();
    // salva o tipo raw para uso futuro
    vestibular.tipoRaw = tipo;
    switch (tipo) {
      case ('T'):
        vestibular.tipo = 'tradicional';
        break;
      case ('A'):
        vestibular.tipo = 'agendado';
        break;
      case ('M'):
        vestibular.tipo = 'medicina';
        break;
    }

    // ead
    vestibular.isEad = vestibular.indicacaoEad === 'S' ? true : false;

    // reingresso
    vestibular.isReingresso = vestibular.sigla === 'RE' || vestibular.sigla ==='RM' ? true : false;

    // enem
    vestibular.isEnem = vestibular.sigla === 'EN' ? true : false;


    if (vestibular.titulo.toLowerCase().indexOf('medicina') !== -1) {
      vestibular.tipo = 'medicina';
    }

    if (vestibular.tipo !== 'agendado' && vestibular.dia && vestibular.dia.length > 0) {
      vestibular.dataVestibular = vestibular.dia[0];
    }

    if (vestibular.dataInscricaoIncial) {
      const dateParts = vestibular.dataInscricaoIncial.split(' ');
      vestibular.dataInscricaoIncial = new Date(`${dateParts[0]}T${dateParts[1]}`);
    }

    if (vestibular.dataInscricaoFinal) {
      const dateParts = vestibular.dataInscricaoFinal.split(' ');
      vestibular.dataInscricaoFinal = new Date(`${dateParts[0]}T${dateParts[1]}`);
    }

    return new Vestibular(vestibular);
  }

  private isValidDate(value): boolean {
    if (!value) {
      return false;
    }

    const dateWrapper = new Date(value);
    return !isNaN(dateWrapper.getDate());
  }

  /************* Novo processo do vestibular **************/
  private getVestibularesDisponiveisPeloCurso(idCurso){
    let url = VESTIBULARES_DISPONIVEIS_POR_CURSO.replace(':codigo',idCurso);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    }
    //console.log(idCurso);
    return this.http.get(url, httpOptions)
    .catch(this.errorHandler);
  }

  errorHandler(error: HttpErrorResponse){
    return Observable.throw(error.message || "Server error");
  }
}
